import { Banner, Sizes, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { TaxReturnTypes } from 'Containers/Result/utils';
import { ResultType } from 'Types/common';
import * as Styled from './styles';

const FLEX_LITE_MANDATORY_CONTEXT = 'isToPayLiteMandatory';

const FlexLiteBannerInfo = ({ data }: { data: ResultType }): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  return (
    <Styled.Container direction="column" fullWidth align="center" gap="dimension_16">
      <Text type="paragraphs" size="M_L_S" color="dark">
        {data.taxReturnType === TaxReturnTypes.TO_PAY
          ? t('FlexLite.Result.title.toPay')
          : t('FlexLite.Result.title', { context: data.taxReturnType })}
      </Text>
      <Banner
        description={t('FlexLite.Result.banner.description', {
          context: data?.mandatory && FLEX_LITE_MANDATORY_CONTEXT,
        })}
        id="flex-lite-banner"
        label={t('FlexLite.Result.banner.title')}
        position="horizontally"
        layout="embed"
        mode="success"
        size={Sizes.M}
        titleSize={Sizes.S}
      />
    </Styled.Container>
  );
};

export default FlexLiteBannerInfo;
